import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/icons/clear.svg'


const _hoisted_1 = {
  class: "field-group is-price-group js-group-fields",
  "data-group": "1"
}
const _hoisted_2 = { class: "field__price-group" }
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 0,
  class: "error-message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["field", { 'has-error': !_ctx.priceIsValid }])
    }, [
      _createElementVNode("label", null, _toDisplayString(_ctx.$t("search.price")), 1),
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.priceFrom) = $event)),
          type: "text",
          oninput: "this.value = this.value.replace(/[^0-9.,]/g, '');",
          placeholder: _ctx.$t('search.from'),
          class: "field__text",
          numeric: "",
          step: "0.1",
          inputmode: "numeric",
          digitOnly: "",
          maxlength: "20",
          formControlName: "resultInput",
          onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.$emit('applyFilters')), ["enter"]))
        }, null, 40, _hoisted_3), [
          [_vModelText, _ctx.priceFrom]
        ]),
        _createElementVNode("a", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clearPrice('priceFrom'))),
          class: _normalizeClass(["js-clear-input clear-input", { 'is-active': _ctx.priceFromUnformatted && _ctx.priceFromUnformatted > 0 }]),
          style: {"cursor":"pointer"}
        }, _hoisted_5, 2),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.priceTo) = $event)),
          type: "text",
          oninput: "this.value = this.value.replace(/[^0-9.,]/g, '');",
          placeholder: _ctx.$t('search.to'),
          class: "field__text",
          numeric: "",
          step: "0.1",
          inputmode: "numeric",
          digitOnly: "",
          maxlength: "20",
          formControlName: "resultInput",
          onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.$emit('applyFilters')), ["enter"]))
        }, null, 40, _hoisted_6), [
          [_vModelText, _ctx.priceTo]
        ]),
        _createElementVNode("a", {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.clearPrice('priceTo'))),
          class: _normalizeClass(["js-clear-input clear-input", { 'is-active': _ctx.priceToUnformatted && _ctx.priceToUnformatted > 0 }]),
          style: {"cursor":"pointer"}
        }, _hoisted_8, 2)
      ]),
      (!_ctx.priceIsValid)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t("search.price_error")), 1))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}